
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-business-photo-generator",
      function () {
        return require("private-next-pages/ai-business-photo-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-business-photo-generator"])
      });
    }
  